export const getExperimentListUrl = () => `analytics/experiments`
